import React from 'react';
import styled from 'styled-components';
import { Button, Container } from '../../Component/styledComponents/styledComponents';
import LicenceImage from '../../Component/Images/licence.jpg';
import {
    ButtonWrapper,
    Heading,
    HeadingSection,
    HeadingWrapper,
    HeadText,
    Icon,
    Image,
    Line,
    List,
    Root,
    Text,
    TextTab,
    Wrapper
} from '../../Component/styledComponents/TermsAndConditionStyledComponents';
import { useNavigate } from 'react-router-dom';


function PrivacyAndPolicy(props) {
    const navigate = useNavigate();
    return (
        <Root>
            <Container>
                <Wrapper>
                    <HeadingSection>
                        <HeadingWrapper>
                            <Heading>Privacy & Policy</Heading>
                            <Line style={{
                                background: "linear-gradient(90deg, #68e7f2, #69e2c1)",
                                height: "20px",
                            }}></Line>
                        </HeadingWrapper>

                    </HeadingSection>
                    <TextTab></TextTab>

                    <Text>
                        This Privacy Policy of bastionex.net governs the collection, storage, handling, and protection of personally identifiable information (PII) and sensitive personal data (hereinafter collectively referred to as "information") of users. All users are urged to read and understand this Privacy Policy, which has been established to safeguard user privacy and outline the steps users can take to protect their information.
                    </Text>

                    <Text>
                        By using our site, you agree to the terms of this Privacy Policy. This policy applies to all users accessing the site via mobile or any other device.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Collection of Information</HeadText>

                    <Text>
                        We collect information from you solely to provide the services available on the site. During registration, we gather user details, including but not limited to name, company name, email address, phone number, postal address, and other business-related information, such as statutory details and tax registration numbers.
                    </Text>

                    <Text>
                        We may also record conversations and archive correspondence between users and site representatives for quality control or training purposes. For paid services, we may collect sensitive information, such as bank account details, to facilitate transactions.
                    </Text>

                    <Text>
                        In addition, we gather and store usage statistics, including IP addresses, pages viewed, user behavior patterns, session counts, and browser information, to improve user experience and provide value-added services.
                    </Text>

                    <Text>
                        Once registered, users are no longer anonymous to us, and all provided information is stored and processed to deliver requested services and comply with legal obligations.
                    </Text>

                    <Text>
                        Users can update, correct, or confirm their information by logging into their accounts or contacting info@bastionex.net. Please note that requested changes may take time due to verification processes.
                    </Text>

                    <Text>
                        Users may also request to delete or deactivate their accounts, which will be evaluated on a case-by-case basis under applicable laws. Information may remain in archival records for compliance or other lawful purposes.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Purpose and Usage of Information</HeadText>

                    <Text>We collect information for the following purposes:</Text>

                    <List><Icon /><Text>To verify identity, eligibility, and registration.</Text></List>
                    <List><Icon /><Text>To facilitate services offered on the site.</Text></List>
                    <List><Icon /><Text>For advertising, marketing, and publication.</Text></List>
                    <List><Icon /><Text>To communicate with users and enhance business opportunities.</Text></List>
                    <List><Icon /><Text>To generate business inquiries and trade leads.</Text></List>
                    <List><Icon /><Text>To send communications, notifications, newsletters, and customized mailers.</Text></List>
                    <List><Icon /><Text>To provide a seamless and convenient user experience.</Text></List>

                    <Text>
                        If you wish to object to any data processing purposes, please contact us at the email provided. Please note that if you withdraw consent for data processing, we may discontinue providing services through the site.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Disclosure of Information</HeadText>

                    <Text>
                        Information collected may be disclosed to external service providers who assist in delivering services to you or us, including:
                    </Text>

                    <List><Icon /><Text>Affiliated companies for improved efficiency and personalized services.</Text></List>
                    <List><Icon /><Text>Government or law enforcement agencies as required by law for identity verification or crime prevention.</Text></List>
                    <List><Icon /><Text>Service providers, including payment processors and cloud computing services, to facilitate user services.</Text></List>
                    <List><Icon /><Text>Business partners for sending independent business offers.</Text></List>

                    <Text>
                        Please note that external websites linked to the site are governed by their privacy policies, and this policy does not apply to those sites. We recommend reviewing their policies before use.
                    </Text>

                    <Text>Disclosure recipients are required to:</Text>

                    <List><Icon /><Text>Limit information sharing to necessary parties and use it solely for the intended business transaction.</Text></List>
                    <List><Icon /><Text>Maintain confidentiality and security of the information.</Text></List>
                    <List><Icon /><Text>Refrain from further disclosing the information and adhere to the site's Privacy Policy.</Text></List>
                    <List><Icon /><Text>Users should be aware that any information posted online may be accessible to the public and could result in unsolicited messages.</Text></List>

                    <Image src={LicenceImage} />

                    <HeadText>Protection of Information</HeadText>

                    <Text>
                        We implement industry-standard security measures to protect against unauthorized access, maintain data accuracy, and ensure proper use of information. While we strive to protect your information, no data transmission over the internet can be guaranteed to be completely secure.
                    </Text>

                    <Text>
                        Users are advised not to share passwords for email accounts, online banking, or other sensitive credentials with our employees or agents, as we will never request such information. Registered users should also log out of their accounts after use, especially on shared or public computers, to prevent unauthorized access.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Cookies</HeadText>

                    <Text>
                        We and our partners may use cookies, pixel tags, web beacons, mobile device IDs, and similar technologies to collect and store information about your use of the site and track visits to third-party websites. Cookies may be used to recognize your browser and provide features like recommendations and personalization.
                    </Text>

                    <Text>
                        Third-party sites accessible through our site may also use cookies or similar tools. We recommend reviewing their privacy policies for information on their practices.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Data Collection Relating to Children</HeadText>

                    <Text>
                        We are committed to protecting the privacy of children. We do not knowingly collect or maintain personally identifiable information from individuals under 18 years of age, and our site is not directed toward them. If you are under 18, please refrain from using our services. If we become aware of any such information collected without verified parental consent, we will delete it promptly. For concerns regarding this, please contact info@bastionex.net.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Data Transfers</HeadText>

                    <Text>
                        Information collected from users may be transferred to and stored with our affiliates, partners, or service providers, whether within or outside the user's country of residence. By submitting your data, you consent to these transfers.
                    </Text>

                    <Text>
                        We will protect your information according to this Privacy Policy and, where necessary, ensure appropriate safeguards are in place to process your data transparently and fairly.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Location Data</HeadText>

                    <Text style={{ marginTop: "10px" }}>
                        <strong>Information Collected</strong>
                    </Text>

                    <Text>
                        When you use our app, we may collect your location information, including precise GPS location and background location, if you grant permission. This may occur even when the app is not actively in use, depending on your device settings.
                    </Text>

                    <Text style={{ marginTop: "10px" }}>
                        <strong>Purpose of Collecting Location Data</strong>
                    </Text>

                    <Text>We use location data to:</Text>
                    <List><Icon /><Text>Provide location-based services and personalized features within the app.</Text></List>
                    <List><Icon /><Text>Improve app functionality, performance, and user experience.</Text></List>
                    <List><Icon /><Text>Analyze usage patterns to enhance services.</Text></List>
                    <List><Icon /><Text>Deliver location-specific notifications, promotions, or content (only if you opt in).</Text></List>

                    <Text style={{ marginTop: "10px" }}>
                        <strong>Third-Party Access</strong>
                    </Text>

                    <Text>
                        We may share location data with trusted third-party service providers to enable app features (e.g., mapping, navigation, analytics). These third parties are contractually obligated to use your location data only for authorized purposes and to maintain strict confidentiality and security.
                    </Text>

                    <Text>
                        You can control or revoke location permissions at any time through your device settings. Disabling location access may limit certain app features.
                    </Text>

                    <Image src={LicenceImage} />

                    <HeadText>Questions</HeadText>

                    <Text>
                        For any questions, clarifications, or concerns regarding this Privacy Policy, please contact us at  info@bastionex.net.
                    </Text>


                    <ButtonWrapper>
                        <Button
                            bgcolor="#00a97c"
                            color="#fff"
                            top="15px"
                            right="30px"
                            bottom="15px"
                            left="30px"
                            radius="30px"
                            onClick={() => (navigate("/contact_us"))}
                        >
                            Contact Us
                        </Button>
                    </ButtonWrapper>
                </Wrapper>
            </Container>
        </Root>
    );
}

export default PrivacyAndPolicy;